import { render, staticRenderFns } from "./application_item.vue?vue&type=template&id=77b0a68c&scoped=true&"
import script from "./application_item.vue?vue&type=script&lang=js&"
export * from "./application_item.vue?vue&type=script&lang=js&"
import style0 from "./application_item.vue?vue&type=style&index=0&id=77b0a68c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0a68c",
  null
  
)

export default component.exports